<form [formGroup]="specialIdentifiersForm">
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInSap']"
        onLabel="{{ 'admin.tools.form.labels.lifeSAP' | translate }}">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInMes']"
        onLabel="{{ 'admin.tools.form.labels.lifeMES' | translate }}">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['isToolLifeMonitoredInPlc']"
        onLabel="{{ 'admin.tools.form.labels.lifePLC' | translate }}">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['hasMaintenaceAtLine']"
        onLabel="{{ 'admin.tools.form.labels.hasMaintenaceAtLine' | translate }}"
        (inputChange)="onToolHasMaintenanceAtLineChanged($event)">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['excludedFromMaintenance']"
        onLabel="{{'admin.tools.form.labels.excludedFromMaintenance' | translate }}"
        (inputChange)="onToolIsExcludedFromMaintenanceChanged($event)">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['isToolStationedAtERSA']"
        onLabel="{{ 'admin.tools.form.labels.isToolStationedAtERSA' | translate }}"
        (inputChange)="onToolStationedAtERSAChanged($event)">
    </app-input-switch>
    <app-input-switch
        [inline]="true"
        [formControl]="specialIdentifiersForm.controls['excludedFromReturn']"
        onLabel="{{ 'admin.tools.form.labels.excludedFromReturn' | translate }}"
        (inputChange)="onToolExcludedFromReturnChanged($event)">
    </app-input-switch>
</form>
